module.exports = __webpack_public_path__ + "static/media/ph_testing_beakers.6d92d0b4.svg";